import {Injectable} from "@angular/core";
import {createFeatureSelector, createSelector, Store} from "@ngrx/store";
import * as fromMarkets from "../reducers/market.reducer";
import {Observable} from "rxjs";
import {Provider} from "../../model/providers";


@Injectable()
export class MarketsSelector {
  constructor(private readonly store: Store) {
  }

  getMarketsState = createFeatureSelector<fromMarkets.State>('markets');

  getMarkets(): Observable<Set<string>> {
    return this.store.select((createSelector(
      this.getMarketsState,
      (state: fromMarkets.State) => {
        return state.currentMarkets;
      }
    )));
  };
}
